import styled from "styled-components";
import { CssRule } from "../../../themes/architecture/css-helpers/css-rule";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";

const UserMenuPictureDefaultBox = styled.img`
    /* .user-menu-box-picture */
    margin-top: -50px;
    ${CssRule.For.mobile.build()} &{
        margin: 0 2rem 0 0;
    }
    ${CssRule.For.RTL.mobile.build()} &{
        margin: 0 0 0 2rem;
    }
`;

/* 777 */
const UserMenuPictureCasino777Box = styled(UserMenuPictureDefaultBox)`
    z-index: 1;
`;

export const UserMenuPictureBox = styledByTheme(UserMenuPictureDefaultBox).forCasino777(UserMenuPictureCasino777Box).apply();
